import React from 'react';
import { classNames } from '@panwds/tailwindcss';

/**
 * Use to space controls like multiple radios or checkboxes on a form.
 */
function ControlGroup({ addClassName, children, dataMetrics, dataTestId, horizontal, ...rest }) {
    const className = classNames('tw-font-lato', horizontal ? 'tw-flex [&_label]:tw-grow' : 'tw-space-y-2', addClassName);
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId || 'control-group', className: className, ...rest }, children));
}

export { ControlGroup };
//# sourceMappingURL=ControlGroup.esm.js.map
